<template>
    <div class="template-info-usps">
        <div class="template-info-usps__header">
            <text-heading>
                Wat heb je eraan:
            </text-heading>
        </div>

        <div class="template-info-usps__content">
            <div
                v-for="(usp, index) in props.usps"
                :key="index"
                class="template-info-usps__entry"
            >
                <div>
                    <svg-icon
                        :icon="IconCheck"
                        :size="IconSize.md"
                        :color="'green-500'"
                        is-custom-icon
                    />
                </div>

                <text-description style="line-height: 1.2rem;">
                    <text-decorator weight="bold" :size="FontSize.sm">
                        {{ usp }}
                    </text-decorator>
                </text-description>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import IconCheck from '@keyvue/one-awesome-icons/icons/solid/check.svg?component';
    import { FontSize, IconSize, SvgIcon } from '@keyvue/one-ui';

    interface Props {
        usps: string[],
    }

    const props = defineProps<Props>();
</script>

<style scoped lang="scss">
.template-info-usps {
    background-color: color(gray-200);
    padding: size(md);
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border-top-left-radius: size(md);

    &__header {
        font-weight: bold;
    }

    &__content {
        display: grid;
        gap: size(sm);
        padding: size(md) 0;
    }

    &__entry {
        display: grid;
        grid-template-columns: min-content auto;
        align-items: center;
        gap: size(sm);
    }
}
</style>
